// These polyfills must be loaded first!
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';
import * as barrelComponents from './components';
import HelloClient from './components/HelloClient';
import ButtonControlledModal from './components/button-controlled-modal/ButtonControlledModal';
import SimpleFooterContainer from './components/connected-footer/FooterContainer';
import SimpleNavContainer from './components/connected-navigation/SimpleNavContainer';
import FooterContainer from './components/footer/FooterContainer';
import PlanSelector from './components/plan-selector/PlanSelector';
import SessionTimerContainer from './components/session-timer/SessionTimerContainer';
import PlanInfoContainer from './components/plan-info/PlanInfoContainer';
import configureStore from './redux/configureStore';
import withProvider from './redux/withProvider';
import { getLayoutData } from './redux/modules/layout';

const moduleActions = {
    layout: getLayoutData
};

/** All components available to [data-react-component] mounts (including barrel exports and legacy aliases). */
const components = toIdentifiers({
    ...barrelComponents,
    HelloClient,
    FooterContainer,
    PlanInfoContainer,
    SimpleNavContainer,
    SimpleFooterContainer,
    ButtonControlledModal,
    PlanSelector,
    SessionTimerContainer
});

if (typeof window !== 'undefined') {
    renderSessionTimer();

    const containers = Array.from(document.querySelectorAll('[data-react-component]'));
    const reduxContainer = document.querySelector('[data-use-redux]');

    const store = initRedux(reduxContainer);
    renderComponents(containers, store);
}

function renderSessionTimer() {
    if (window.location.href.indexOf('account/login') > -1) {
        return;
    }

    const sessionTimerRoot = document.getElementById('SessionTimer');
    if (!sessionTimerRoot) {
        return;
    }

    const remainingSessionTimeInMs = sessionTimerRoot.dataset.remainingsessiontimeinms;
    const logoutUrl = sessionTimerRoot.dataset.logouturl;

    const sessionTimer = React.createElement(SessionTimerContainer, {
        remainingSessionTimeInMs,
        logoutUrl
    });

    const root = createRoot(sessionTimerRoot);
    root.render(sessionTimer);
    return root;
}

function initRedux(container) {
    if (!container) {
        return undefined;
    }

    const initialState = tryParse(container.dataset.initialState);
    const store = configureStore(initialState);

    const modules = tryParse(container.dataset.modules);
    if (modules) {
        modules.forEach(({ name, endpoint }) => {
            const action = moduleActions[name];
            store.dispatch(action(endpoint));
        });
    }

    return store;
}

function renderComponents(containers, store) {
    containers.forEach(container => {
        const props = tryParse(container.dataset.props);
        const isConnected = container.dataset.connected === 'true';

        const component = components[container.dataset.reactComponent];
        if (!component) {
            console.warn(
                '[Employee.Account.UI] No React component registered for data-react-component=%s',
                container.dataset.reactComponent
            );
            return;
        }

        const element = isConnected
            ? React.createElement(withProvider(component, store), props)
            : React.createElement(component, props);

        const root = createRoot(container);
        root.render(element);
        return root;
    });
}

function toIdentifiers(componentMap) {
    return Object.keys(componentMap).reduce((allComponents, id) => {
        allComponents[id.toLowerCase()] = componentMap[id];
        return allComponents;
    }, {});
}

function tryParse(str) {
    return str ? JSON.parse(str) : undefined;
}
